import { gql } from '@apollo/client';

export const ORDER_GIFT_CARD = gql`
  mutation OrderGiftCard($data: OrderGiftCardInput!) {
    orderGiftCard(data: $data) {
      ... on KennitalaNotFoundError {
        message
      }
      ... on CrmCasePayload {
        success
      }
    }
  }
`;
